import React from "react";
import PropTypes from "prop-types";

import { Delete, Input, Field, Control, Button, Icon } from "rbx";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const DirectionInputRow = ({
  direction = { text: "", miles: 0 },
  handleChange,
  handleBlur,
  removeRow,
  insertAfter,
  disabled = false
}) => (
  <Field kind="group" onBlur={handleBlur}>
    <Control>
      <div style={{ display: "flex", alignItems: "center", height: "100%" }}>
        <Delete
          disabled={disabled}
          style={{ opacity: disabled ? 0 : 1 }}
          onClick={removeRow}
        />
      </div>
    </Control>
    <Control expanded>
      <Input
        disabled={disabled}
        name="text"
        type="text"
        value={direction.text}
        onChange={handleChange}
      />
    </Control>
    <Control>
      <Input
        disabled={disabled || !direction.text}
        name="miles"
        type="number"
        value={direction.miles ? parseFloat(direction.miles) : 0}
        onChange={handleChange}
      />
    </Control>
    <Control>
      <Button
        color="link"
        disabled={disabled}
        style={{ opacity: disabled ? 0 : 1 }}
        type="button"
        onClick={insertAfter}
      >
        <Icon>
          <FontAwesomeIcon icon="plus" />
        </Icon>
      </Button>
    </Control>
  </Field>
);

DirectionInputRow.propTypes = {
  direction: PropTypes.string,
  handleBlur: PropTypes.func,
  handleChange: PropTypes.func,
  removeRow: PropTypes.func,
  insertAfter: PropTypes.func,
  disabled: PropTypes.bool
};
export default DirectionInputRow;
